import React from 'react'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'

import SearchIcon from '../images/search-icon';

export default function SearchPopup() {
  return (
    <Popup modal nested trigger={
      <button 
        type="button" 
        id="search-modal-btn" 
        className="popup-with-zoom-anim" 
        style={{
          height: '40px',
          width: '40px',
        }}
      >
        <SearchIcon />
      </button>
      
    }>
      {close => (
        <div id="search-modal" className="bioBox maincopy">
          <button className="close" onClick={close}>
            &times;
          </button>

          <p style={{ fontSize: '24px' }}><strong>Search our site</strong></p>

          <form className="headerSearch" action="/search/" style={{ width: '100%', margin: 0 }}>
            <input type="text" placeholder="Search Our Site..." name="q" />
            <button type="submit"><i className="far fa-search"></i></button>
          </form>
        </div>
      )}
    </Popup>
  )
}
